import Scrolly from './components/Scrolly';
import Carousel from './components/Carousel';
import Header from './components/Header';
import Youtube from './components/Youtube';
import Tabs from './components/Tabs';
import TypeWriter from './components/TypeWriter';
import Modal from './components/Modal';

export default class ComponenentFactory {
  constructor() {
    this.componentList = {
      Carousel,
      Header,
      Scrolly,
      Youtube,
      Tabs,

      TypeWriter,
      Modal,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');
    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        new this.componentList[componentName](element);
      } else {
        console.log(
          `La composante ${componentName} n'existe pas ou ne fonction pas!`
        );
      }
    }
  }
}
